import "./accountCancelViewWizardStep2.scss";

import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';
const { FormattedText } = i18n;

import PersonalDataHelper from 'utilities/personalDataHelper';

import { OKMessage } from 'commonsComponents/OKMessage';
import { OKButton } from 'commonsComponents/OKButton';
import { taggingPersonalDataLinkClickEvent } from "../../helpers/tagging";

const baseClassName = "account-cancel-view-wizard-step2";


function AccountCancelViewWizardStep2(props) {
    const { immProfile, history, setPreLeaveIsPersonalData, immAccountCancel} = props;

    const handlePersonalDataLinkClick = () => {
        setPreLeaveIsPersonalData(true);
        taggingPersonalDataLinkClickEvent(immAccountCancel);
        history.push('/myprofile/edit');
    }

    const email = PersonalDataHelper.getEmail(immProfile);
    const phone = PersonalDataHelper.getPhoneNumber(immProfile);

    return <article className={baseClassName}>
        <h2 className={`${baseClassName}__title`}><FormattedText value="cancellation_account-account_cancellation_request_step2_title" /></h2>
        <p className={`${baseClassName}__subtitle`}><FormattedText value="cancellation_account-account_cancellation_request_step2_sub_title" /></p>
        <section className={`${baseClassName}__contact-data`}>
            <div className={`${baseClassName}__contact-data-item`}>
                <p><FormattedText value="mortgageRequestCommons-phone" /></p>
                <p className={`${baseClassName}__contact-data-item-value`}>{phone}</p>
            </div>
            <div className={`${baseClassName}__contact-data-item`}>
                <p><FormattedText value="profile-contactData_email" /></p>
                <p className={`${baseClassName}__contact-data-item-value`}>{email}</p>
            </div>
        </section>
        <section>
            {
                !__CONTACT_CENTER__ && (
                    <OKMessage type="informative">
                        <FormattedText value="cancellation_account-account_cancellation_request_step2_disclaimer" />
                        <OKButton modifier="link-emphasize" onClick={handlePersonalDataLinkClick}>
                            <FormattedText value="contractsView-personalDataTitle" />
                        </OKButton>
                    </OKMessage>
                )
            }
            {
                __CONTACT_CENTER__ && (
                    <div className={`${baseClassName}__disclaimer-cc`}>
                        <i className={`${baseClassName}__disclaimer-cc-icon icon-informacion`}></i>
                        <p className={`${baseClassName}__disclaimer-cc-text`}>
                            <FormattedText value="cancellation_account_CC-account_cancellation_request_step2_disclaimer_cc" />
                        </p>
                    </div>
                )
            }

        </section>
    </article>
};

AccountCancelViewWizardStep2.propTypes = {
    immAccountCancel: PropTypes.object.isRequired,
    immProfile: PropTypes.shape({
        email: PropTypes.string,
        phoneNumber: PropTypes.string,
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    setPreLeaveIsPersonalData: PropTypes.func.isRequired,
};

export default AccountCancelViewWizardStep2;